export const getLenswoodData = () => ({
  name: "Lenswood",
  country: "Australie",
  region: "Adelaide Hills",
  description: "Lenswood est une sous-région d'altitude des Adelaide Hills, réputée pour ses Pinot Noir élégants et ses Chardonnay complexes. Son climat frais et ses vignobles en altitude créent des conditions idéales pour des vins de grande finesse.",
  type: "subregion",
  mapAreas: [
    { region: "Lenswood", x: 43, y: 78, color: "#f0e0f0", size: 3 }
  ],
  statistics: {
    totalArea: "1,200 ha",
    production: "0.08 million hectolitres",
    altitude: "500-600m",
    appellations: "Lenswood GI",
    exportPercentage: "30%"
  },
  characteristics: {
    climate: "Climat frais avec altitude élevée, étés chauds, hivers froids, précipitations régulières",
    soil: "Sols volcaniques, argileux, excellente drainage",
    viticulture: "Viticulture moderne, vignobles en altitude, rendements limités"
  },
  wineStyles: {
    red: "Pinot Noir élégants et complexes, Shiraz frais, assemblages délicats",
    white: "Chardonnay frais et aromatiques, Sauvignon Blanc tendus, Riesling complexes",
    rose: "Rosés frais et fruités, parfaits pour l'apéritif",
    sparkling: "Vins effervescents de méthode traditionnelle"
  },
  history: "Lenswood s'est développée comme sous-région distincte dans les années 1980. La sous-région s'est rapidement imposée pour ses vins de climat frais de qualité exceptionnelle.",
  foodPairing: "Cuisine australienne : fruits de mer, poissons, viandes blanches, fromages affinés, cuisine fusion.",
  grapeVarieties: {
    white: ["Chardonnay", "Sauvignon Blanc", "Riesling"],
    red: ["Pinot Noir", "Shiraz", "Cabernet Sauvignon"]
  },
  keyProducers: ["Shaw + Smith", "Tapanappa", "Ashton Hills"],
  notableWines: {
    "pinot-noir": "Pinot Noir élégants et complexes",
    "chardonnay": "Chardonnay frais et aromatiques",
    "shiraz": "Shiraz frais et élégants"
  }
}); 